/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export var PrivacyFilter;
(function (PrivacyFilter) {
    PrivacyFilter["ALL"] = "ALL";
    PrivacyFilter["PRIVATE"] = "PRIVATE";
    PrivacyFilter["PUBLIC"] = "PUBLIC";
})(PrivacyFilter || (PrivacyFilter = {}));
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export var ActiveFilter;
(function (ActiveFilter) {
    ActiveFilter["ALL"] = "ALL";
    ActiveFilter["ACTIVE"] = "ACTIVE";
    ActiveFilter["UNACTIVE"] = "UNACTIVE";
})(ActiveFilter || (ActiveFilter = {}));
//# sourceMappingURL=types.js.map